import { useCallback } from 'react';
import { useNotionContext } from '../context';
import { hashKey } from '@simpledotink/notion-utils';
export function useCollection() {
    var _a = useNotionContext(), recordMap = _a.recordMap, fetchPage = _a.fetchPage, fetchHashmap = _a.fetchHashmap;
    var retrieveCollectionId = useCallback(function (block) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var viewIds = block.view_ids;
        var collectionId = ((_d = (_c = (_b = (_a = recordMap.collection_view[viewIds === null || viewIds === void 0 ? void 0 : viewIds[0]]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.format) === null || _c === void 0 ? void 0 : _c.collection_pointer) === null || _d === void 0 ? void 0 : _d.id) ||
            ((_f = (_e = block === null || block === void 0 ? void 0 : block.format) === null || _e === void 0 ? void 0 : _e.collection_pointer) === null || _f === void 0 ? void 0 : _f.id);
        if (!collectionId) {
            // find the
            var views = (_g = Object.entries((recordMap === null || recordMap === void 0 ? void 0 : recordMap.block) || {})) === null || _g === void 0 ? void 0 : _g.filter(function (entry) {
                var _a, _b;
                return ((_b = (_a = entry[1]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.type) == 'collection_view';
            }).map(function (entry) { return entry[1].value; });
            collectionId = (_h = views.find(function (b) {
                return b.created_by_id == block.created_by_id && b.collection_id;
            })) === null || _h === void 0 ? void 0 : _h.collection_id;
        }
        return collectionId;
    }, [recordMap]);
    var retrievePage = useCallback(function (page) {
        var key = hashKey({ data: page });
        if (fetchPage && page.length > 0 && !fetchHashmap[key])
            fetchPage(page);
    }, [fetchHashmap, fetchPage]);
    return { retrieveCollectionId: retrieveCollectionId, retrievePage: retrievePage };
}
//# sourceMappingURL=useCollection.js.map